import { ColumnType } from '@datachain/ui-sdk/components/dc-types';

import { SubscriptionSyncStatus } from '../../requesters/subscription/models/subscription.model';
import { ColumnModelItemEntity } from './column-model-item.entity';
import { FilterModelItemEntity } from './filter-model-item.entity';
import { ProfileItemEntity } from './profile-item.entity';

export type DatablockColumn = {
	id: string;
	label: string;
	type: ColumnType;
	isList: boolean;
	isHashed: boolean;
};

export enum SubscriptionStatus {
	Unpublish = 'unpublished',
	Available = 'available',
	UnAvailable = 'unavailable',
	Running = 'running',
	Waiting = 'waiting',
	Success = 'success',
	Error = 'failed',
	Unknown = 'unknown',
}

export enum ConsumeStatus {
	Paused = 'paused',
	Absent = 'absent',
	NotUsed = 'not-used',
	InProgress = 'in-progress',
	Unknown = 'unknown',
}

export enum ColumnStatus {
	Warning = 'warning',
	None = 'none',
}

export type SubscriptionAction =
	| 'initialize'
	| 'update-data'
	| 'in-progress'
	| 'none';

export type ProfileConfigType = {
	metadata: ProfileItemEntity;
	columnModels: Array<ColumnModelItemEntity>;
	filterModels: Array<FilterModelItemEntity>;
};

export type SimulationDataSource = 'DATABLOCK' | 'PUBLISH_DATA';

export type SimulationSortColumnType = {
	uuid: string;
	order: 'asc' | 'desc';
};

export type SyncWithSnapshotStatus = `${SubscriptionSyncStatus}` | 'N/A';

export enum FilterVersion {
	CurrentVersion = 'current-version',
	AllVersions = 'all-versions',
	OtherVersions = 'other-versions',
}

export type OperationType = 'initialize' | 'update-data';
